import React from "react";
import ReactDOM from "react-dom/client";
import TouristGuide from "./Tour_main";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-datepicker/dist/react-datepicker.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <TouristGuide />
  </React.StrictMode>
);
